import script from "./addAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./addAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./addAdminPage.vue?vue&type=style&index=0&id=0f3ee744&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3ee744"]])

export default __exports__